
import React, { useEffect, useState } from 'react';
import './css/referalModal.css';
import { getloggedInUser } from '../../Utilities/getloggedInUser';
import { useLocation } from 'react-router-dom';
import isEmpty from '../../Utilities/is_empty';
import store from '../../store';
import { GET_USER_REFERRAL_CODE } from '../../Actions/types';
import { useSelector } from 'react-redux';
import { ReduxRootState } from '../../Interfaces/ReduxInterface/ReduxRootState';

declare global {
  interface Window {
    RF: any;
    RFW: any;
    handleReferralResponse: ((data: any) => void) | null | undefined;
  }
}
const ReferralModal: React.FC = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { loggedInUser } = getloggedInUser()
  const location = useLocation();

  const referralLink = useSelector((state: ReduxRootState) => state.users.user_referral_link)
  const [enableReferralFactory, setEnableReferralFactory] = useState(false);
  const [iframeUrl, setIframeUrl] = useState<string>("https://embed.referral-factory.com/c7U0EX5S?source=Widget")


  const updateReferralFactory = () => {
    const company = JSON.parse(localStorage.getItem('company') || '{}');
    setEnableReferralFactory(company.enable_referral_factory || false);
  };

  useEffect(() => {
    updateReferralFactory();
  }, [location.pathname]);


  const handleOpenModal = () => {
    setIsOpen(true);
  };

  const handleCloseModal = () => {
    setIsOpen(false);
  };

  useEffect(() => {

    const scriptDataString = JSON.stringify({
      user: {
        first_name: `${loggedInUser?.first_name}`,
        email: `${loggedInUser?.email}`,
        last_name: `${loggedInUser?.last_name}`
      },
    });

    window.RF = JSON.parse(scriptDataString);
    
    if (!isEmpty(loggedInUser) && isEmpty(referralLink) && enableReferralFactory) {
      console.log('logged in User! ');
      const script = document.createElement('script');
      script.src = 'https://referral-factory.com/assets/js/widget.js?code=c7U0EX5S';
      script.id = 'rf-script';
      script.async = true;
      script.type = 'text/javascript';


      const head = document.head;
      if (head) {
        head.appendChild(script);
      }
      script.onload = () => {
        console.log('Referral Factory script loaded successfully');
      };
      window.handleReferralResponse = (data: any) => {
        if (data.url){
          setIframeUrl(data.url);
          store.dispatch({
            type: GET_USER_REFERRAL_CODE,
            payload: data.url
          })
        }else{
          const referralResponseUrl = window.RFW && window.RFW.params.url
          setIframeUrl(referralResponseUrl)
          console.log('Referral Factory data failed to set url');
        }
      };
    

      return () => {
        if (head) {
          head.removeChild(script);
        }
      };
    }
    // eslint-disable-next-line
  }, [enableReferralFactory, loggedInUser, location.pathname, referralLink, isOpen]);

  const handleReferralResponse = (data: any) => {
    setIframeUrl(data.url);
  };

 
  useEffect(() => {
    if (window.handleReferralResponse) {
      window.handleReferralResponse = handleReferralResponse;
    }
  }, []);


  return (
    <>
      {(!isOpen && enableReferralFactory) && (
        <button className="refer-button" onClick={handleOpenModal}>
          <span className='cursor-pointer'>
            <img src='/imgs/chowmill-logo.png' height="35" width="25" alt="Refer & Earn $350" />
            <span className='ml-3'><strong>Refer & Earn $350</strong></span>
          </span>
        </button>
      )}
      {isOpen && (
        <div className="refer-modal-overlay">
          <div className="refer-modal-content">
            <div className='refer-modal-header'>
              <button className='btn p-3 refer-modal-close-btn' onClick={handleCloseModal}>
                <i className="fa-regular fa-xmark fa-2x"></i>
              </button>
              <div className='mx-2 refer-modal-heading'>Refer Friends </div>
            </div>
            <iframe
              key={iframeUrl}
              src={iframeUrl}
              title="Referral Factory Widget"
              style={{ width: '100%', height: '700px', border: 'none' }}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default ReferralModal;
